import { createContext } from "react";

const AddCategoryContext = createContext();

export default AddCategoryContext;
